import { render } from "./ZoneJourneySchemas.vue?vue&type=template&id=00288710&ts=true"
import script from "./ZoneJourneySchemas.vue?vue&type=script&lang=ts"
export * from "./ZoneJourneySchemas.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Zones/ZoneJourneySchemas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00288710"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00288710', __exports__)) {
    api.reload('00288710', __exports__)
  }
  
  module.hot.accept("./ZoneJourneySchemas.vue?vue&type=template&id=00288710&ts=true", () => {
    api.rerender('00288710', render)
  })

}


export default __exports__